<div class="modal-overlay" [class.open]="open" (click)="onBackdrop($event)">
    <div
        class="modal"
        [class.modal-wide]="width === 'wide'"
        [class.modal-xl]="width === 'xl'"
    >
        <ng-content></ng-content>
    </div>
</div>
